import React, { useEffect, useState, useRef } from "react";
import { Card, Table, Alert, Spinner, Dropdown, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
export default function GoPartner() {
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  var history = useHistory();
  const [searchData, setSearchData] = useState([]);
  const [onboardUser, setOnBoardUser] = useState([]);
  const [onboardID, setOnBoardID] = useState("");
  const [commission, setCommission] = useState();
  const [vehicleName, setVehicleName] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [vehicleNameObject, setVehicleNameObject] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [show, setShow] = useState(false);
  const [blockStatus, setBlockStatus] = useState(false);
  const [vehicle, setpushvehicle] = useState([]);
  var nameObject = [
    "Auto",
    "Bike",
    "3 Wheeler",
    "Tata Ace",
    "PickUp 8ft",
    "Tata 407",
    "SUV/MUV",
    "Sedan",
    "Hatch Back",
  ];
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  function getData() {
    axios
      .get(`${Baseurl.baseurl2}/onboarding/get-all-onboarding`)
      .then((res) => {
        setSpinner(false);
        setOnBoardUser(res.data.OnBoardingList);
        setSearchData(res.data.OnBoardingList);
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);
  function searchRider(value) {
    let filteredData = [];
    if(searchData){
      searchData.map((val) => {
        let phoneString = val.Phone.toString();
        if (
          val.Name.toLowerCase().includes(value) ||
          val.Email.toLowerCase().includes(value) ||
          val.EntityType.toLowerCase().includes(value)||
          phoneString.includes(value)
        ) {
          filteredData.push(val);
        }
      });
      setOnBoardUser(filteredData);
    }
   
  }
  const Add = () => {
    let cmm=parseInt(commission)
    const vehicle1 = {
      VehicleType: vehicleName,
      VehicleCommission: cmm,
    };
    setpushvehicle(
      (oldArray) => oldArray.concat(vehicle1),
      () => {}
    );
    swal("Added", "Added successfully", "success", {
      showCancelButton: true,
      timer: 1000,
    });
    setCommission("");
  };

  function submitHandler() {
    const artical = {
      CommissionModel: vehicle,
    };
    axios
      .put(
        `${Baseurl.baseurl2}/onboarding/add-perticular-onboarding-commission/${onboardID}`,
        artical
      )
      .then(
        (response) =>
          response.data.status
            ? swal("Commission Added", response.data.message, "success", {
                button: "Done",
                timer: 1000,
              })
            : swal("Oops", response.data.message, "error", {
                button: "Try Again!",
                timer: 1000,
              }),
        setpushvehicle([]),
        setVehicleName(''),
        setShow(false),
        getData()
      )
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }

  function blockPartner(){
    axios
      .put(
        `${Baseurl.baseurl2}/onboarding/block-onboarding-center/${onboardID}`)
      .then(
        (response) =>
        
         { if(response.data.status)
             {
              swal("Blocked", response.data.message, "success", {
                button: "Done",
                timer: 1000,
              })
              setShow(false)
              getData()
            }
            else
            { swal("Oops", response.data.message, "error", {
                button: "Try Again!",
                timer: 1000,
              })}
       
      }
      )
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  return (
    <Card
      style={{
        color: "white",
        background:
          "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
      }}
    >
      <Modal
        size="md"
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{blockStatus?"Block Partner":"Add Vehicle"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {blockStatus?(
          <div className="row">
             <h4>Are you sure you want to block</h4><h4 className="ml-2 text-danger">{partnerName} ?</h4>
          </div>
          ):(
            <div>
            <div className="col-auto">
              <label>Vehicle Type</label>
              <div className="input-group mb-2">
                <select
                  className="form-control"
                  id="val-skill"
                  name="val-skill"
                  defaultValue={vehicleName}
                  onChange={(event) => {
                    setVehicleName(event.target.value);
                  }}
                >
                  <option selected="true" disabled="disabled"></option>
                  {vehicleNameObject &&
                    vehicleNameObject.map((val) => (
                      <option value={val}>{val}</option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-auto">
              <label>Commission</label>
              <div className="input-group mb-2">
                <input
                  type="number"
                  className="form-control"
                  placeholder="in %"
                  defaultValue={commission}
                  onChange={(e) => {
                    setCommission(e.target.value);
                  }}
                />
              </div>
            </div>
            <button onClick={Add} className="btn btn-primary mt-2 ml-3">
              Add
            </button>
            <Table responsive id="myTable">
              <thead>
                <tr>
                  <th>
                    <strong>Vehicle Name</strong>
                  </th>

                  <th>
                    <strong>Commission</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* <tr> */}
                {vehicle.map((p, i) => (
                  <tr key={i}>
                    <td>{p.VehicleType}</td>
                    <td>{p.VehicleCommission}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          )}
          
        </Modal.Body>
        <Modal.Footer>
          {blockStatus?(
             <button
             onClick={() => {
               blockPartner()
             }}
             className="btn btn-primary"
           >
             Block
           </button>
          ):(
             <button
             onClick={() => {
               submitHandler();
             }}
             className="btn btn-primary"
           >
             Submit
           </button>
          )}
         
        </Modal.Footer>
      </Modal>
      <Card.Header>
        <Card.Title className="text-white">All Partners</Card.Title>
        <div>
          <input
            type="text"
            className="form-control"
            placeholder="Search here..."
            onChange={(e) => {
              searchRider(e.target.value);
            }}
          />
        </div>
      </Card.Header>
      <Card.Body>
        <div id="job_data" className="dataTables_wrapper ">
          {spinner ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Table className="text-white" responsive>
              <thead>
                <tr>
                  <th>
                    <strong>SL NO.</strong>
                  </th>

                  <th>
                    <strong>NAME</strong>
                  </th>

                  <th>
                    <strong>Phone No.</strong>
                  </th>
                  <th>
                    <strong>Entity Type</strong>
                  </th>
                  <th>
                    <strong>Address</strong>
                  </th>
                  <th>
                    <strong>Actions</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {onboardUser &&
                  onboardUser.map((rider, key) => (
                    <tr key={rider.id}>
                      <td>{key + 1}</td>

                      <td>{rider.Name}</td>

                      <td>{rider.Phone}</td>
                      <td>{rider.EntityType}</td>
                      <td>
                        {rider.OfficeAddress} {rider.OfficePincode}
                      </td>

                      <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="warning"
                            className="light sharp i-false"
                          >
                            {svg1}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                history.push(`./view-partner/${rider._id}`);
                              }}
                            >
                              View
                            </Dropdown.Item>

                            {/* <Dropdown.Item
                              onClick={() => {
                                history.push(
                                  `./partner-commission/${rider._id}`
                                );
                              }}
                            >
                              Add Commission
                            </Dropdown.Item> */}
                            <Dropdown.Item
                              onClick={() => {
                                setOnBoardID(rider._id);
                                setShow(true);
                                setBlockStatus(false)
                                let vig = [];
                                if (rider.CommissionModel) {
                                  rider.CommissionModel.map((val) => {
                                    vig.push(val.VehicleType);
                                  });
                                }
                                var array3 = nameObject.filter(function(obj) {
                                  return vig.indexOf(obj) == -1;
                                });
                                setVehicleNameObject(array3)
                              }}
                            >
                              Add Vehicle
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                history.push(`./view-commission/${rider._id}`);
                              }}
                            >
                              View Commission
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                history.push(`./partner-rider/${rider._id}`);
                              }}
                            >
                              View Onboarded Rider
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setBlockStatus(true)
                                setShow(true);
                                setPartnerName(rider.Name)
                                setOnBoardID(rider._id);
                              }}
                            >
                              Block Partner
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}

          {!onboardUser && (
            <Alert
              variant="success"
              className="alert-dismissible fade show text-center"
            >
              Zero Partners
            </Alert>
          )}
          <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
            <div className="dataTables_info text-white">
              Showing {activePag.current * sort + 1} to{" "}
              {data.length > (activePag.current + 1) * sort
                ? (activePag.current + 1) * sort
                : data.length}{" "}
              of {data.length} entries
            </div>
            <div
              className="dataTables_paginate paging_simple_numbers"
              id="example5_paginate"
            >
              <Link
                className="paginate_button previous disabled"
                onClick={() =>
                  activePag.current > 0 && onClick(activePag.current - 1)
                }
              >
                Previous
              </Link>
              <span>
                {paggination.map((number, i) => (
                  <Link
                    key={i}
                    className={`paginate_button  ${
                      activePag.current === i ? "current" : ""
                    } `}
                    onClick={() => onClick(i)}
                  >
                    {number}
                  </Link>
                ))}
              </span>
              <Link
                className="paginate_button next"
                onClick={() => {
                  activePag.current + 1 < paggination.length &&
                    onClick(activePag.current + 1);
                }}
              >
                Next
              </Link>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
